import soft from '../../styles/soft.module.css'
import { useAuthShell } from '../../wallet/AuthShellContext'

/** The one way to the login dialog: the Soft action unless the surface passes
 *  a class of its own (the header's Log in, the rail's). */
export function GuestAuthButtons({ className }: { className?: string }) {
  const { openAuth } = useAuthShell()
  return (
    <button type="button" className={className ?? soft.action} onClick={() => openAuth('chooser')}>
      Log in
    </button>
  )
}
